export default [   
    "remarkable",
    "exceptional",
    "amazing",
    "astonishing",
    "astounding",
    "marvellous",
    "wonderful",
    "sensational",
    "stunning",
    "incredible",
    "unbelievable",
    "miraculous",
    "phenomenal",
    "prodigious",
    "spectacular",
    "striking",
    "outstanding",
    "impressive",
    "memorable",
    "unforgettable",
    "unique",
    "great",
    "fantastic",
    "terrific",
    "tremendous",
    "stupendous",
    "awesome",
    "out of this world",
    "unreal",
]